import React from 'react'
import styled from 'styled-components';
import TriasuresCover from '../../assets/img/triasures_cover.png'
import {maxWidth} from '../common/StyleValue'

const HeadStyle = styled.div`
  height: 380px;
  background: #000;
  .top-box {
    width: ${maxWidth}px;
    margin: auto;
    height: 100%;
  }
  .topbg {
    height: 100%;
    width: 70%;
    background-position: 50%;
    background-size: cover;
    background-image: url(${TriasuresCover});
  }
  @media (max-width: 768px) {
    height: 200px;
    .top-box {
      width: 100%;
    }
    .topbg {
      width: 100%;
    }
  }
`;

export default function Head() {
  return (
    <HeadStyle>
      <div className="top-box">
        <div className="topbg"></div>
      </div>
    </HeadStyle>
  )
}
